import { useState, useEffect } from "react"
import Popover from "@mui/material/Popover"
import Typography from "@mui/material/Typography"

const EditCategoryModal = ({ category, setRefresh }) => {
  const [message, setMessage] = useState("")
  const [name, setName] = useState("")
  const [image, setImage] = useState("")
  const [subCategories, setSubCategories] = useState([])
  const [subImages, setSubImages] = useState({})
  const [newSub, setNewSub] = useState("")
  const [anchorEl, setAnchorEl] = useState(null)

  useEffect(() => {
    if (!category) return

    setName(category?.name ?? "")
    setImage(category?.image ?? "") // ✅ FIXED
    setSubCategories(category?.subCategories ?? []) // ✅ flat array
    setSubImages(category?.subCategoryImages ?? {})
  }, [category])

  const updateCategory = async (event) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/categories/${category._id}`,
        {
          method: "PUT",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: name.trim(),
            image: image.trim(), // ✅ FIXED
            subCategories,
            subCategoryImages: subImages,
          }),
        },
      )

      if (res.ok) {
        setMessage("Category updated successfully")
        setRefresh(true)
      } else {
        setMessage("Failed to update category")
      }
    } catch {
      setMessage("Server error")
    }

    setAnchorEl(event.currentTarget)
  }

  const addSubCategory = () => {
    if (!newSub.trim()) return
    setSubCategories([...subCategories, newSub.trim()])
    setNewSub("")
  }

  const removeSubCategory = (index) => {
    const updated = subCategories.filter((_, i) => i !== index)
    setSubCategories(updated)
  }

  const handleClose = () => setAnchorEl(null)
  const open = Boolean(anchorEl)

  return (
    <>
      <div
        className="modal fade"
        id="editCategoryModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            {/* HEADER */}
            <div className="modal-header">
              <h1 className="modal-title fs-4">Edit Category</h1>
              <button className="btn-close" data-bs-dismiss="modal" />
            </div>

            {/* BODY */}
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label fs-5">Name</label>
                <input
                  className="form-control form-control-lg"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label fs-5">Image URL</label>
                <input
                  className="form-control form-control-lg"
                  value={image}
                  onChange={(e) => setImage(e.target.value)}
                />
              </div>

              {/* SUBCATEGORIES */}
              <div className="mb-3">
                <label className="form-label fs-5">Sub-Categories</label>

                {subCategories.map((sub, i) => (
                  <div
                    key={i}
                    className="d-flex justify-content-between align-items-center border rounded p-2 mt-2"
                  >
                    {subImages[sub] ? (
                      <img
                        src={subImages[sub]}
                        alt=""
                        width={40}
                        height={40}
                        className="rounded me-2 flex-shrink-0"
                        style={{ objectFit: "cover" }}
                      />
                    ) : (
                      <span className="rounded me-2 bg-secondary-subtle flex-shrink-0" style={{ width: 40, height: 40 }} />
                    )}
                    <span className="me-2 flex-shrink-0" style={{ minWidth: "9rem" }}>{sub}</span>
                    <input
                      className="form-control form-control-sm me-2"
                      placeholder="Picture URL (shown in the sign-up dropdown)"
                      aria-label={`Picture URL for ${sub}`}
                      value={subImages[sub] || ""}
                      onChange={(e) => setSubImages({ ...subImages, [sub]: e.target.value })}
                    />
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => removeSubCategory(i)}
                    >
                      Remove
                    </button>
                  </div>
                ))}

                <div className="d-flex mt-3">
                  <input
                    className="form-control me-2"
                    value={newSub}
                    onChange={(e) => setNewSub(e.target.value)}
                    placeholder="New sub-category"
                  />
                  <button
                    className="btn btn-outline-success"
                    onClick={addSubCategory}
                  >
                    Add
                  </button>
                </div>
              </div>

              <div className="text-end">
                <button
                  className="btn btn-success px-4"
                  data-bs-dismiss="modal"
                  onClick={updateCategory}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STATUS */}
      <Popover open={open} anchorEl={anchorEl} onClose={handleClose}>
        <Typography sx={{ p: 2 }}>{message}</Typography>
      </Popover>
    </>
  )
}

export default EditCategoryModal
